export * from './partners-selection.model';
